import { render, staticRenderFns } from "./ReflectionEdit.vue?vue&type=template&id=01d2a838&scoped=true&"
import script from "./ReflectionEdit.vue?vue&type=script&lang=js&"
export * from "./ReflectionEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d2a838",
  null
  
)

export default component.exports